export const CONDITION_OPERATOR = { AND: 'AND', OR: 'OR', NOT: 'NOT' };
